"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _appendCss = _interopRequireDefault(require("../utils/appendCss"));
var _arcUiReact = require("@accessdev/arc-ui-react");
var _CookieBanner_css = _interopRequireDefault(require("./CookieBanner_css"));
function CookieBanner(_ref) {
  let {
    className = "",
    privacyLinkUrl = "#",
    maxWidth = "960px",
    onClick = null
  } = _ref;
  (0, _appendCss.default)("arc_cookiebanner", _CookieBanner_css.default);
  const [hideBanner, setHideBanner] = _react.default.useState(window.localStorage.getItem("AdcCookieBanner") ? true : false);
  const handleCookieBannerClick = () => {
    window.localStorage.setItem("AdcCookieBanner", "acknowledged");
    setHideBanner(true);
    if (onClick) {
      onClick();
    }
  };
  if (hideBanner) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  } else {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: `CookieBanner ${className}`,
      style: {
        maxWidth: maxWidth
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "CookieBanner-content"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "CookieBanner-message t-body-small"
    }, "We use cookies to help personalize content, tailor and measure experiences, and provide a safer experience. By navigating the site, you agree to the use of cookies to collect information. Read our", " ", /*#__PURE__*/_react.default.createElement("a", {
      href: privacyLinkUrl,
      rel: "noopener noreferrer",
      target: "_blank"
    }, "Privacy Policy"), " ", "to learn more."), /*#__PURE__*/_react.default.createElement("div", {
      className: "CookieBanner-action"
    }, /*#__PURE__*/_react.default.createElement(_arcUiReact.Button, {
      type: "button",
      className: "CookieBanner-button",
      onClick: handleCookieBannerClick
    }, "OK"))));
  }
}
CookieBanner.propTypes = {
  /** A css class name added to the this instance of the CookieBanner */
  className: _propTypes.default.string,
  /** The link to the privacy policy for the given app */
  privacyLinkUrl: _propTypes.default.string.isRequired,
  /** Adjust the max width of the banner for the given app */
  maxWidth: _propTypes.default.string,
  /** onClick event handler fired as a callback when they user closes the banner */
  onClick: _propTypes.default.func
};
var _default = exports.default = CookieBanner;